import React, { useState } from 'react';
import { usePostHog } from 'posthog-js/react';
export function WaitlistSection() {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const posthog = usePostHog();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Track form submission attempt
    posthog?.capture('waitlist_form_submitted', {
      has_feedback: feedback.length > 0,
      feedback_length: feedback.length
    });
    const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSexy9IHphcpPyw7_9FEuMwQqHnRr6_Lej-RiFacH3MWmvURAA/formResponse';
    const data = new URLSearchParams();
    data.append('entry.1886379184', email);
    data.append('entry.1039892389', feedback);
    try {
      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data.toString()
      });
      // Track successful submission
      posthog?.capture('waitlist_signup_completed', {
        has_feedback: feedback.length > 0
      });
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail('');
      setFeedback('');
    } catch (error) {
      // Even errors might indicate success with no-cors
      posthog?.capture('waitlist_signup_completed', {
        has_feedback: feedback.length > 0
      });
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail('');
      setFeedback('');
    }
  };
  return <section id="waitlist" className="w-full bg-[#FAF8F5] px-6 py-16 md:py-24 flex flex-col items-center" data-id="element-189">
      <div className="max-w-xl w-full" data-id="element-190">
        <div className="text-center mb-10" data-id="element-191">
          <h2 className="font-['DM_Sans'] text-3xl md:text-4xl font-medium text-[#3A3A3A] mb-4" data-id="element-192">
            Join the waitlist
          </h2>
          <p className="text-lg text-[#3A3A3A]/70" data-id="element-193">
            Be the first to know when Cardkeeper launches on iOS.
          </p>
        </div>

        {isSuccess ? <div className="bg-[#2D4A3E]/10 border border-[#2D4A3E]/20 rounded-2xl p-8 text-center animate-fade-in" data-id="element-194">
            <h3 className="font-['DM_Sans'] text-xl font-medium text-[#2D4A3E] mb-2" data-id="element-195">
              You're on the list!
            </h3>
            <p className="text-[#3A3A3A]/80" data-id="element-196">
              Thank you for your interest. We'll be in touch soon.
            </p>
            <button onClick={() => setIsSuccess(false)} className="mt-6 text-[#2D4A3E] font-medium underline hover:text-[#2D4A3E]/80" data-id="element-197">
              Add another email
            </button>
          </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-198">
            <div data-id="element-199">
              <label htmlFor="email" className="block text-sm font-medium text-[#3A3A3A] mb-2" data-id="element-200">
                Email address <span className="text-[#C4887C]" data-id="element-201">*</span>
              </label>
              <input type="email" id="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" className="w-full px-4 py-3 rounded-lg bg-white border border-[#B8A99A]/40 text-[#3A3A3A] placeholder-[#B8A99A] focus:outline-none focus:border-[#2D4A3E] focus:ring-1 focus:ring-[#2D4A3E] transition-colors" data-id="element-202" />
            </div>

            <div data-id="element-203">
              <label htmlFor="feedback" className="block text-sm font-medium text-[#3A3A3A] mb-2" data-id="element-204">
                Want priority access? Tell us about your holiday cards
              </label>
              <textarea id="feedback" rows={4} value={feedback} onChange={e => setFeedback(e.target.value)} placeholder="Every year I save cards in a shoebox, but I never look at them again..." className="w-full px-4 py-3 rounded-lg bg-white border border-[#B8A99A]/40 text-[#3A3A3A] placeholder-[#B8A99A] focus:outline-none focus:border-[#2D4A3E] focus:ring-1 focus:ring-[#2D4A3E] transition-colors resize-none" data-id="element-205" />
              <p className="mt-2 text-xs text-[#B8A99A]" data-id="element-206">
                Optional: What do you do with holiday cards today? Why does this
                product resonate with you?
              </p>
            </div>

            <button type="submit" disabled={isSubmitting} className="w-full bg-[#2D4A3E] text-[#FAF8F5] py-3.5 rounded-full font-medium text-lg shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-200 active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none" data-id="element-207">
              {isSubmitting ? 'Joining...' : 'Join the Waitlist'}
            </button>

            <p className="text-center text-sm text-[#B8A99A]" data-id="element-208">
              We'll email you when the app is ready. No spam, ever.
            </p>
          </form>}
      </div>
    </section>;
}